const shopMapModule = document.querySelector('.sc-shop-map-old');

if (shopMapModule) {
  // Initialize script settings object
  const script_settings = {
    map: {
      is_ios: /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream,
      shops_by_internal_number: {
        1: {
          id_shop: 73,
          title: 'Osare Caffe',
          logo: '',
          pin_icon: '',
          category: 'restaurants',
          link: '',
          'first-floor': {
            'background-position': '-507px -1046px',
            coords: '896,681,965,709,958,750,920,816,853,786,857,740',
            height: '137',
            left: '858',
            pins: {
              height: '7',
              left: '928',
              'normal-background-position': '-816px -211px',
              top: '755',
              width: '4',
            },
            top: '679',
            width: '115',
          },
        },
        3: {
          id_shop: 5,
          title: 'Office&More',
          logo: '',
          pin_icon: '',
          category: 'bookstores',
          link: '',
          'first-floor': {
            'background-position': '-507px -908px',
            coords: '842,659,802,716,800,760,734,732,736,687',
            height: '130',
            left: '739',
            pins: {
              height: '7',
              left: '802',
              'normal-background-position': '-271px -154px',
              top: '703',
              width: '5',
            },
            top: '632',
            width: '112',
          },
        },
        4: {
          id_shop: 74,
          title: 'Sanolabor',
          logo: '',
          pin_icon: '',
          category: 'special',
          link: '',
          'first-floor': {
            'background-position': '-507px -722px',
            coords: '716,607,778,632,736,687,734,732,668,701,669,656',
            height: '127',
            left: '673',
            pins: {
              height: '7',
              left: '737',
              'normal-background-position': '-271px -139px',
              top: '672',
              width: '5',
            },
            top: '606',
            width: '114',
          },
        },
        6: {
          id_shop: 8,
          title: 'Calzedonia',
          logo: '',
          pin_icon: '',
          category: 'fashion',
          link: '',
          'first-floor': {
            'background-position': '-651px -8px',
            coords: '602,561,654,582,606,630,609,675,553,649,555,607',
            height: '117',
            left: '559',
            pins: {
              height: '7',
              left: '602',
              'normal-background-position': '-816px -286px',
              top: '614',
              width: '6',
            },
            top: '559',
            width: '102',
          },
        },
        7: {
          id_shop: 9,
          title: 'Intimissimi',
          logo: '',
          pin_icon: '',
          category: 'fashion',
          link: '',
          'first-floor': {
            'background-position': '-564px -193px',
            coords: '536,534,600,561,556,608,552,649,486,577',
            height: '120',
            left: '488',
            pins: {
              height: '7',
              left: '551',
              'normal-background-position': '-816px -256px',
              top: '592',
              width: '5',
            },
            top: '533',
            width: '119',
          },
        },
        8: {
          id_shop: 10,
          title: 'T-2',
          logo: '',
          pin_icon: '',
          category: 'services',
          link: '',
          'first-floor': {
            'background-position': '-761px -61px',
            coords: '436,523,460,534,469,573,438,592,413,584,410,543',
            height: '74',
            left: '414',
            pins: {
              height: '7',
              left: '435',
              'normal-background-position': '-816px -241px',
              top: '542',
              width: '5',
            },
            top: '521',
            width: '59',
          },
        },
        9: {
          id_shop: 11,
          title: 'Niammi',
          logo: '',
          pin_icon: '',
          category: 'restaurants',
          link: '',
          'first-floor': {
            'background-position': '-751px -1024px',
            coords: '413,512,437,523,410,543,413,582,392,574,387,533',
            height: '75',
            left: '389',
            pins: {
              height: '7',
              left: '408',
              'normal-background-position': '-816px -226px',
              top: '529',
              width: '5',
            },
            top: '511',
            width: '52',
          },
        },
        10: {
          id_shop: 33,
          title: 'Telemach',
          logo: '',
          pin_icon: '',
          category: 'electronics',
          link: '',
          'first-floor': {
            'background-position': '-734px -860px',
            coords: '336,464,364,495,373,533,345,552,300,532,294,492',
            height: '91',
            left: '295',
            pins: {
              height: '7',
              left: '336',
              'normal-background-position': '-410px -139px',
              top: '498',
              width: '10',
            },
            top: '462',
            width: '81',
          },
        },
        11: {
          id_shop: 93,
          title: 'Mohito',
          logo: '',
          pin_icon: '',
          category: 'fashion',
          link: '',
          'first-floor': {
            'background-position': '-284px -200px',
            coords:
              '359,415,392,427,398,465,362,489,336,463,293,493,300,532,290,537,254,522,242,529,140,481,130,442,198,401,235,416,272,395,344,426',
            height: '155',
            left: '130',
            pins: {
              height: '7',
              left: '282',
              'normal-background-position': '-775px -469px',
              top: '481',
              width: '9',
            },
            top: '384',
            width: '272',
          },
        },
        12: {
          id_shop: 99,
          title: 'Kopitarna',
          logo: '',
          pin_icon: '',
          category: 'shoes',
          link: '',
          'first-floor': {
            'background-position': '-507px -857px',
            coords: '285,384,360,414,346,425,272,394',
            height: '43',
            left: '272',
            pins: {
              height: '7',
              left: '342',
              'normal-background-position': '-591px -321px',
              top: '413',
              width: '10',
            },
            top: '384',
            width: '94',
          },
        },
        13: {
          id_shop: 95,
          title: 'Galileo',
          logo: '',
          pin_icon: '',
          category: 'fashion',
          link: '',
          'first-floor': {
            'background-position': '-284px -139px',
            coords: '284,385,233,416,192,396,256,373',
            height: '46',
            left: '191',
            pins: {
              height: '7',
              left: '236',
              'normal-background-position': '-792px -469px',
              top: '403',
              width: '9',
            },
            top: '372',
            width: '99',
          },
        },
        14: {
          id_shop: 61,
          title: 'Zlatarstvo GEMA',
          logo: '',
          pin_icon: '',
          category: 'watch_stores',
          link: '',
          'first-floor': {
            'background-position': '-391px -154px',
            coords: '188,396,196,400,147,432,189,395',
            height: '29',
            left: '161',
            pins: {
              height: '7',
              left: '186',
              'normal-background-position': '-609px -321px',
              top: '399',
              width: '10',
            },
            top: '395',
            width: '40',
          },
        },
        15: {
          id_shop: 27,
          title: '\u010cakula Bar',
          logo: '',
          pin_icon: '',
          category: 'restaurants',
          link: '',
          'first-floor': {
            'background-position': '-659px -565px',
            coords: '70,363,133,390,146,427,116,445,47,415,38,378',
            height: '86',
            left: '37',
            pins: {
              height: '7',
              left: '101',
              'normal-background-position': '-809px -469px',
              top: '397',
              width: '9',
            },
            top: '362',
            width: '112',
          },
        },
        20: {
          id_shop: 22,
          title: 'Lisca',
          logo: '',
          pin_icon: '',
          category: 'fashion',
          link: '',
          'first-floor': {
            'background-position': '-761px -8px',
            coords: '330,262,356,274,358,291,336,301,329,305,327,288,306,281,306,274',
            height: '45',
            left: '308',
            pins: {
              height: '7',
              left: '332',
              'normal-background-position': '-8px -8px',
              top: '272',
              width: '11',
            },
            top: '262',
            width: '54',
          },
        },
        21: {
          id_shop: 21,
          title: 'Comma,',
          logo: '',
          pin_icon: '',
          category: 'fashion',
          link: '',
          'first-floor': {
            'background-position': '-8px -351px',
            coords: '324,241,381,259,382,277,358,290,356,274,327,263,306,274,305,278,273,269,273,264',
            height: '52',
            left: '274',
            pins: {
              height: '7',
              left: '356',
              'normal-background-position': '-265px -351px',
              top: '260',
              width: '10',
            },
            top: '240',
            width: '112',
          },
        },
        22: {
          id_shop: 20,
          title: 'Okaidi',
          logo: '',
          pin_icon: '',
          category: 'fashion',
          link: '',
          'first-floor': {
            'background-position': '-444px -138px',
            coords: '353,227,377,233,373,238,404,248,404,266,382,277,381,259,322,241',
            height: '54',
            left: '324',
            pins: {
              height: '7',
              left: '380',
              'normal-background-position': '-27px -8px',
              top: '247',
              width: '11',
            },
            top: '225',
            width: '85',
          },
        },
        23: {
          id_shop: 19,
          title: 'Vitapur',
          logo: '',
          pin_icon: '',
          category: 'home',
          link: '',
          'first-floor': {
            'background-position': '-734px -959px',
            coords: '384,211,433,226,436,255,428,255,405,266,403,247,374,238,378,233,355,225',
            height: '57',
            left: '355',
            pins: {
              height: '7',
              left: '403',
              'normal-background-position': '-410px -393px',
              top: '235',
              width: '10',
            },
            top: '210',
            width: '85',
          },
        },
        24: {
          id_shop: 18,
          title: 'Hervis',
          logo: '',
          pin_icon: '',
          category: 'fashion',
          link: '',
          'first-floor': {
            'background-position': '-8px -411px',
            coords: '529,140,633,165,513,235,511,263,436,251,435,225,394,212,394,208',
            height: '332',
            left: '203',
            pins: {
              height: '7',
              left: '507',
              'normal-background-position': '-46px -8px',
              top: '222',
              width: '11',
            },
            top: '140',
            width: '439',
          },
        },
        25: {
          id_shop: 17,
          title: 'New Yorker',
          logo: '',
          pin_icon: '',
          category: 'fashion',
          link: '',
          'first-floor': {
            'background-position': '-444px -8px',
            coords: '633,165,707,183,596,255,596,284,513,263,513,234',
            height: '122',
            left: '517',
            pins: {
              height: '7',
              left: '591',
              'normal-background-position': '-65px -8px',
              top: '241',
              width: '11',
            },
            top: '165',
            width: '199',
          },
          'second-floor': {
            'background-position': '-534px -469px',
            coords: '655,274,720,289,613,359,611,391,602,382,564,371,542,370,546,335',
            height: '121',
            left: '550',
            pins: {
              height: '7',
              left: '611',
              'normal-background-position': '-854px -230px',
              top: '345',
              width: '10',
            },
            top: '274',
            width: '179',
          },
        },
        26: {
          id_shop: 16,
          title: 'C&A',
          logo: '',
          pin_icon: '',
          category: 'fashion',
          link: '',
          'first-floor': {
            'background-position': '-455px -593px',
            coords: '708,183,781,201,780,211,769,208,668,276,652,300,596,285,598,253',
            height: '121',
            left: '600',
            pins: {
              height: '7',
              left: '666',
              'normal-background-position': '-84px -8px',
              top: '262',
              width: '11',
            },
            top: '182',
            width: '196',
          },
          'second-floor': {
            'background-position': '-370px -710px',
            coords: '723,289,797,305,797,315,783,312,685,383,680,417,614,358',
            height: '133',
            left: '618',
            pins: {
              height: '7',
              left: '682',
              'normal-background-position': '-394px -178px',
              top: '368',
              width: '10',
            },
            top: '287',
            width: '187',
          },
        },
        27: {
          id_shop: 15,
          title: 'H&M',
          logo: '',
          pin_icon: '',
          category: 'fashion',
          link: '',
          'first-floor': {
            'background-position': '-8px -172px',
            coords: '767,208,846,230,846,243,903,259,901,278,896,278,789,375,787,359,644,317,644,311,668,277',
            height: '171',
            left: '644',
            pins: {
              height: '7',
              left: '659',
              'normal-background-position': '-410px -378px',
              top: '302',
              width: '10',
            },
            top: '208',
            width: '268',
          },
        },
        28: {
          id_shop: 69,
          title: 'Tezenis',
          logo: '',
          pin_icon: '',
          category: 'fashion',
          link: '',
          'first-floor': {
            'background-position': '-128px -351px',
            coords: '637,316,706,338,672,365,602,341',
            height: '50',
            left: '604',
            pins: {
              height: '7',
              left: '668',
              'normal-background-position': '-103px -8px',
              top: '351',
              width: '11',
            },
            top: '316',
            width: '111',
          },
        },
        29: {
          id_shop: 112,
          title: 'Terranova',
          logo: '',
          pin_icon: '',
          category: 'fashion',
          link: '',
          'first-floor': {
            'background-position': '-202px -8px',
            coords: '704,337,788,363,788,378,728,433,727,417,672,399,621,441,586,429,631,395,561,371',
            height: '123',
            left: '562',
            pins: {
              height: '7',
              left: '631',
              'normal-background-position': '-122px -8px',
              top: '382',
              width: '11',
            },
            top: '337',
            width: '234',
          },
        },
        30: {
          id_shop: 66,
          title: 'Ghetaldus Optika',
          logo: '',
          pin_icon: '',
          category: 'special',
          link: '',
          'first-floor': {
            'background-position': '-691px -143px',
            coords: '559,372,631,397,588,429,514,403',
            height: '60',
            left: '516',
            pins: {
              height: '7',
              left: '585',
              'normal-background-position': '-410px -363px',
              top: '418',
              width: '10',
            },
            top: '371',
            width: '123',
          },
        },
        31: {
          id_shop: 13,
          title: 'Bershka',
          logo: '',
          pin_icon: '',
          category: 'fashion',
          link: '',
          'first-floor': {
            'background-position': '-8px -23px',
            coords: '514,404,674,463,675,482,628,525,628,507,600,494,585,504,584,540,529,519,495,457,492,419',
            height: '141',
            left: '496',
            pins: {
              height: '7',
              left: '538',
              'normal-background-position': '-629px -565px',
              top: '470',
              width: '9',
            },
            top: '403',
            width: '186',
          },
        },
        32: {
          id_shop: 12,
          title: 'Loterija Slovenije',
          logo: '',
          pin_icon: '',
          category: 'special',
          link: '',
          'first-floor': {
            'background-position': '-775px -484px',
            coords: '600,493,629,505,629,523,625,528,624,545,614,551,586,543,586,505',
            height: '61',
            left: '590',
            pins: {
              height: '7',
              left: '612',
              'normal-background-position': '-141px -8px',
              top: '504',
              width: '11',
            },
            top: '494',
            width: '44',
          },
        },
        33: {
          id_shop: 1,
          title: 'Tu\u0161 hipermarket',
          logo: '',
          pin_icon: '',
          category: 'food',
          link: '',
          'first-floor': {
            'background-position': '-8px -751px',
            coords:
              '896,279,1003,308,1000,330,1021,337,1016,365,1050,379,1046,406,1090,420,1084,454,1109,471,1102,498,990,665,952,649,945,662,942,697,898,678,900,667,856,649,846,658,625,568,626,529',
            height: '431',
            left: '630',
            pins: {
              height: '7',
              left: '651',
              'normal-background-position': '-428px -393px',
              top: '525',
              width: '10',
            },
            top: '279',
            width: '491',
          },
        },
        34: {
          id_shop: 2,
          title: 'Klju\u010davni\u010darstvo Tripar',
          logo: '',
          pin_icon: '',
          category: 'services',
          link: '',
          'first-floor': {
            'background-position': '-760px -757px',
            coords: '955,651,989,667,984,704,974,721,964,716,964,708,942,697,946,663',
            height: '74',
            left: '948',
            pins: {
              height: '7',
              left: '982',
              'normal-background-position': '-428px -378px',
              top: '666',
              width: '10',
            },
            top: '649',
            width: '53',
          },
        },
        35: {
          id_shop: 110,
          title: 'Khan',
          logo: '',
          pin_icon: '',
          category: 'services',
          link: '',
          'first-floor': {
            'background-position': '0px 0px',
            coords: '509,264,537,268,559,277,522,278,508,267',
            height: 0,
            left: 0,
            pins: {
              height: '33',
              left: '527',
              'normal-background-position': '-691px -297px',
              top: '243',
              width: '19',
            },
            top: 0,
            width: 0,
          },
        },
        36: {
          id_shop: 65,
          title: 'PANDORA',
          logo: '',
          pin_icon: '',
          category: 'watch_stores',
          link: '',
          'first-floor': {
            'background-position': '-202px -139px',
            coords: '522,277,558,275,574,282,557,293,518,282',
            height: '17',
            left: '520',
            pins: {
              height: '7',
              left: '557',
              'normal-background-position': '-160px -8px',
              top: '280',
              width: '11',
            },
            top: '277',
            width: '61',
          },
        },
        37: {
          id_shop: 37,
          title: 'Telekom',
          logo: '',
          pin_icon: '',
          category: 'electronics',
          link: '',
          'first-floor': {
            'background-position': '-779px -568px',
            coords: '574,282,587,285,598,302,597,333,590,337,589,303,558,294',
            height: '59',
            left: '560',
            pins: {
              height: '7',
              left: '585',
              'normal-background-position': '-428px -363px',
              top: '291',
              width: '10',
            },
            top: '281',
            width: '43',
          },
        },
        38: {
          id_shop: 36,
          title: 'Stradivarius',
          logo: '',
          pin_icon: '',
          category: 'fashion',
          link: '',
          'first-floor': {
            'background-position': '-455px -363px',
            coords: '532,286,589,306,590,337,517,389,516,354,459,331',
            height: '105',
            left: '459',
            pins: {
              height: '7',
              left: '516',
              'normal-background-position': '-179px -8px',
              top: '338',
              width: '11',
            },
            top: '286',
            width: '137',
          },
        },
        39: {
          id_shop: 35,
          title: 'Zlatarna Celje',
          logo: '',
          pin_icon: '',
          category: 'watch_stores',
          link: '',
          'first-floor': {
            'background-position': '-721px -378px',
            coords: '459,333,514,353,518,389,482,413,478,379,422,356',
            height: '83',
            left: '423',
            pins: {
              height: '7',
              left: '477',
              'normal-background-position': '-807px -361px',
              top: '366',
              width: '10',
            },
            top: '333',
            width: '100',
          },
        },
        40: {
          id_shop: 34,
          title: 'Douglas',
          logo: '',
          pin_icon: '',
          category: 'drugstores',
          link: '',
          'first-floor': {
            'background-position': '-630px -1024px',
            coords: '420,357,480,379,480,414,435,435,394,426,374,419,371,389',
            height: '81',
            left: '373',
            pins: {
              height: '7',
              left: '426',
              'normal-background-position': '-664px -133px',
              top: '383',
              width: '11',
            },
            top: '356',
            width: '113',
          },
        },
        41: {
          id_shop: 44,
          title: 's.Oliver',
          logo: '',
          pin_icon: '',
          category: 'fashion',
          link: '',
          'first-floor': {
            'background-position': '-455px -476px',
            coords: '442,312,473,321,367,389,368,417,320,398,318,369,388,326,407,331',
            height: '109',
            left: '320',
            pins: {
              height: '7',
              left: '361',
              'normal-background-position': '-779px -553px',
              top: '371',
              width: '9',
            },
            top: '310',
            width: '166',
          },
        },
        42: {
          id_shop: 101,
          title: 'Skechers',
          logo: '',
          pin_icon: '',
          category: 'shoes',
          link: '',
          'first-floor': {
            'background-position': '-629px -757px',
            coords: '364,317,388,325,319,368,320,396,292,387,287,357,292,328,301,330,300,340,323,343',
            height: '95',
            left: '289',
            pins: {
              height: '7',
              left: '315',
              'normal-background-position': '-391px -139px',
              top: '351',
              width: '11',
            },
            top: '317',
            width: '123',
          },
        },
        44: {
          id_shop: 41,
          title: 'Bags&More',
          logo: '',
          pin_icon: '',
          category: 'fashion',
          link: '',
          'first-floor': {
            'background-position': '-537px -138px',
            coords: '369,285,442,311,405,331,331,306',
            height: '47',
            left: '332',
            pins: {
              height: '7',
              left: '403',
              'normal-background-position': '-807px -331px',
              top: '321',
              width: '10',
            },
            top: '286',
            width: '119',
          },
        },
        45: {
          id_shop: 40,
          title: 'Deichmann',
          logo: '',
          pin_icon: '',
          category: 'shoes',
          link: '',
          'first-floor': {
            'background-position': '-630px -1113px',
            coords: '438,256,532,285,476,321,370,287,424,256,437,256',
            height: '68',
            left: '370',
            pins: {
              height: '7',
              left: '477',
              'normal-background-position': '-807px -316px',
              top: '310',
              width: '10',
            },
            top: '254',
            width: '169',
          },
        },
        46: {
          id_shop: 39,
          title: 'Slowatch',
          logo: '',
          pin_icon: '',
          category: 'watch_stores',
          link: '',
          'first-floor': {
            'background-position': '-327px -363px',
            coords: '468,250,508,267,508,275,438,256',
            height: '27',
            left: '439',
            pins: {
              height: '7',
              left: '494',
              'normal-background-position': '-807px -301px',
              top: '263',
              width: '10',
            },
            top: '252',
            width: '75',
          },
        },
        47: {
          id_shop: 75,
          title: 'Mobia store',
          logo: '',
          pin_icon: '',
          category: 'electronics',
          link: '',
          'first-floor': {
            'background-position': '0px 0px',
            coords: '469,498,498,513,482,531,458,520',
            height: 0,
            left: 0,
            pins: {
              height: '34',
              left: '473',
              'normal-background-position': '-664px -148px',
              top: '484',
              width: '19',
            },
            top: 0,
            width: 0,
          },
        },
        49: {
          id_shop: 104,
          title: 'Family Fun',
          logo: '',
          pin_icon: '',
          category: 'services',
          link: '',
          'second-floor': {
            'background-position': '-305px -400px',
            coords: '722,659,878,718,825,791,819,843,659,775,660,724',
            height: '188',
            left: '664',
            pins: {
              height: '7',
              left: '821',
              'normal-background-position': '-864px -140px',
              top: '774',
              width: '11',
            },
            top: '658',
            width: '221',
          },
        },
        50: {
          id_shop: 81,
          title: 'Teta Frida',
          logo: '',
          pin_icon: '',
          category: 'restaurants',
          link: '',
          'second-floor': {
            'background-position': '-442px -8px',
            coords: '598,612,721,659,659,726,658,774,598,748,596,721,548,700,545,652,554,646,564,621',
            height: '165',
            left: '549',
            pins: {
              height: '7',
              left: '656',
              'normal-background-position': '-864px -155px',
              top: '709',
              width: '11',
            },
            top: '611',
            width: '180',
          },
        },
        51: {
          id_shop: 105,
          title: 'A1',
          logo: '',
          pin_icon: '',
          category: 'electronics',
          link: '',
          'second-floor': {
            'background-position': '-779px -99px',
            coords: '463,582,504,600,506,642,497,671,490,676,435,655,431,607',
            height: '98',
            left: '434',
            pins: {
              height: '7',
              left: '485',
              'normal-background-position': '-722px -186px',
              top: '615',
              width: '9',
            },
            top: '581',
            width: '77',
          },
        },
        52: {
          id_shop: 63,
          title: 'Turisti\u010dna agencija Palma',
          logo: '',
          pin_icon: '',
          category: 'services',
          link: '',
          'second-floor': {
            'background-position': '-835px -496px',
            coords: '438,574,463,582,430,607,436,655,412,643,407,598',
            height: '84',
            left: '409',
            pins: {
              height: '7',
              left: '428',
              'normal-background-position': '-739px -186px',
              top: '593',
              width: '10',
            },
            top: '572',
            width: '59',
          },
        },
        53: {
          id_shop: 64,
          title: 'Samsonite',
          logo: '',
          pin_icon: '',
          category: 'fashion',
          link: '',
          'second-floor': {
            'background-position': '-790px -595px',
            coords: '391,565,440,573,407,595,412,644,374,628,368,581',
            height: '83',
            left: '369',
            pins: {
              height: '7',
              left: '405',
              'normal-background-position': '-739px -201px',
              top: '583',
              width: '10',
            },
            top: '563',
            width: '76',
          },
        },
        54: {
          id_shop: 90,
          title: 'Sinsay',
          logo: '',
          pin_icon: '',
          category: 'fashion',
          link: '',
          'second-floor': {
            'background-position': '-8px -877px',
            coords: '142,413,256,453,292,435,412,474,409,482,416,526,312,592,286,597,52,499,38,459',
            height: '190',
            left: '37',
            pins: {
              height: '7',
              left: '285',
              'normal-background-position': '-836px -205px',
              top: '539',
              width: '10',
            },
            top: '411',
            width: '384',
          },
        },
        55: {
          id_shop: 45,
          title: 'Cineplexx',
          logo: '',
          pin_icon: '',
          category: 'special',
          link: '',
          'second-floor': {
            'background-position': '-8px -669px',
            coords:
              '341,324,348,330,348,333,450,362,427,378,482,391,395,443,428,453,441,446,490,461,492,507,468,521,435,511,417,515,410,474,295,433,259,452,142,411',
            height: '200',
            left: '142',
            pins: {
              height: '7',
              left: '461',
              'normal-background-position': '-864px -170px',
              top: '466',
              width: '11',
            },
            top: '324',
            width: '354',
          },
        },
        56: {
          id_shop: 46,
          title: 'Tu\u0161 drogerija',
          logo: '',
          pin_icon: '',
          category: 'drugstores',
          link: '',
          'second-floor': {
            'background-position': '-630px -81px',
            coords: '451,411,531,435,531,477,492,504,490,464,441,445,430,453,396,441',
            height: '97',
            left: '397',
            pins: {
              height: '7',
              left: '488',
              'normal-background-position': '-864px -185px',
              top: '448',
              width: '11',
            },
            top: '410',
            width: '141',
          },
        },
        57: {
          id_shop: 47,
          title: 'Sizeer',
          logo: '',
          pin_icon: '',
          category: 'fashion',
          link: '',
          'second-floor': {
            'background-position': '-713px -326px',
            coords: '492,387,570,412,569,451,533,477,532,435,453,410',
            height: '92',
            left: '454',
            pins: {
              height: '7',
              left: '532',
              'normal-background-position': '-836px -220px',
              top: '422',
              width: '10',
            },
            top: '387',
            width: '122',
          },
        },
        58: {
          id_shop: 48,
          title: 'BUZZ',
          logo: '',
          pin_icon: '',
          category: 'fashion',
          link: '',
          'second-floor': {
            'background-position': '-535px -186px',
            coords: '463,356,600,394,599,432,575,448,570,410,492,387,484,389,428,377',
            height: '97',
            left: '428',
            pins: {
              height: '7',
              left: '570',
              'normal-background-position': '-836px -235px',
              top: '398',
              width: '10',
            },
            top: '356',
            width: '179',
          },
        },
        59: {
          id_shop: 49,
          title: 'Da-Do',
          logo: '',
          pin_icon: '',
          category: 'fashion',
          link: '',
          'second-floor': {
            'background-position': '-782px -925px',
            coords: '525,372,563,372,604,383,606,388,609,427,597,433,599,394',
            height: '62',
            left: '522',
            pins: {
              height: '7',
              left: '599',
              'normal-background-position': '-864px -200px',
              top: '382',
              width: '11',
            },
            top: '370',
            width: '93',
          },
        },
        60: {
          id_shop: 50,
          title: 'CCC',
          logo: '',
          pin_icon: '',
          category: 'shoes',
          link: '',
          'second-floor': {
            'background-position': '-565px -820px',
            coords:
              '460,277,530,295,492,314,497,328,500,364,464,355,453,362,421,353,420,346,437,337,380,322,364,331,363,337,348,332,348,328',
            height: '90',
            left: '351',
            pins: {
              height: '7',
              left: '437',
              'normal-background-position': '-872px -233px',
              top: '342',
              width: '10',
            },
            top: '277',
            width: '184',
          },
        },
        61: {
          id_shop: 51,
          title: 'Baby Center',
          logo: '',
          pin_icon: '',
          category: 'fashion',
          link: '',
          'second-floor': {
            'background-position': '-535px -349px',
            coords: '597,261,656,275,544,337,543,371,502,364,498,330,490,310',
            height: '112',
            left: '494',
            pins: {
              height: '7',
              left: '541',
              'normal-background-position': '-895px -23px',
              top: '323',
              width: '9',
            },
            top: '261',
            width: '170',
          },
        },
        64: {
          id_shop: 52,
          title: 'Mass',
          logo: '',
          pin_icon: '',
          category: 'shoes',
          link: '',
          'second-floor': {
            'background-position': '-630px -8px',
            coords: '746,339,860,367,859,385,840,382,819,401,684,397,684,382',
            height: '65',
            left: '688',
            pins: {
              height: '7',
              left: '694',
              'normal-background-position': '-873px -218px',
              top: '388',
              width: '10',
            },
            top: '338',
            width: '181',
          },
        },
        65: {
          id_shop: 106,
          title: 'NES',
          logo: '',
          pin_icon: '',
          category: 'fashion',
          link: '',
          'second-floor': {
            'background-position': '-305px -596px',
            coords: '685,402,730,399,697,425,697,455,681,446,682,419',
            height: '57',
            left: '686',
            pins: {
              height: '7',
              left: '694',
              'normal-background-position': '-883px -203px',
              top: '406',
              width: '10',
            },
            top: '399',
            width: '52',
          },
        },
        67: {
          id_shop: 96,
          title: 'Jack&Jones',
          logo: '',
          pin_icon: '',
          category: 'fashion',
          link: '',
          'second-floor': {
            'background-position': '-836px -250px',
            coords: '791,439,840,451,822,475,819,501,771,484,772,455',
            height: '66',
            left: '776',
            pins: {
              height: '7',
              left: '820',
              'normal-background-position': '-883px -173px',
              top: '460',
              width: '10',
            },
            top: '439',
            width: '73',
          },
        },
        69: {
          id_shop: 88,
          title: 'Sport Vision',
          logo: '',
          pin_icon: '',
          category: 'fashion',
          link: '',
          'second-floor': {
            'background-position': '-8px -290px',
            coords: '922,513,1057,507,1094,519,1086,557,1043,632,1041,613,884,566',
            height: '137',
            left: '891',
            pins: {
              height: '7',
              left: '904',
              'normal-background-position': '-883px -143px',
              top: '556',
              width: '10',
            },
            top: '507',
            width: '213',
          },
        },
        70: {
          id_shop: 80,
          title: 'Polleo Sport',
          logo: '',
          pin_icon: '',
          category: 'fashion',
          link: '',
          'second-floor': {
            'background-position': '-565px -720px',
            coords: '884,566,1042,614,1039,639,1034,650,1027,647,1027,639,869,587',
            height: '88',
            left: '874',
            pins: {
              height: '7',
              left: '885',
              'normal-background-position': '-892px -128px',
              top: '578',
              width: '10',
            },
            top: '564',
            width: '177',
          },
        },
        71: {
          id_shop: 77,
          title: 'Optika Clarus',
          logo: '',
          pin_icon: '',
          category: 'electronics',
          link: '',
          'second-floor': {
            'background-position': '-257px -148px',
            coords: '868,587,944,612,929,633,853,609',
            height: '48',
            left: '858',
            pins: {
              height: '7',
              left: '869',
              'normal-background-position': '-895px -8px',
              top: '601',
              width: '8',
            },
            top: '587',
            width: '94',
          },
        },
        72: {
          id_shop: 86,
          title: 'Subway',
          logo: '',
          pin_icon: '',
          category: 'restaurants',
          link: '',
          'second-floor': {
            'background-position': '-669px -598px',
            coords: '852,609,927,634,900,674,893,720,819,693,825,649',
            height: '114',
            left: '825',
            pins: {
              height: '7',
              left: '838',
              'normal-background-position': '-892px -113px',
              top: '642',
              width: '10',
            },
            top: '609',
            width: '113',
          },
        },
        73: {
          id_shop: 108,
          title: 'Bazilika',
          logo: '',
          pin_icon: '',
          category: 'restaurants',
          link: '',
          'second-floor': {
            'background-position': '-257px -204px',
            coords: '944,613,1028,640,1027,646,1094,672,1090,687,1128,701,1114,751,1095,797,894,722,900,674',
            height: '188',
            left: '869',
            pins: {
              height: '7',
              left: '918',
              'normal-background-position': '-359px -178px',
              top: '670',
              width: '9',
            },
            top: '611',
            width: '270',
          },
        },
        74: {
          id_shop: 84,
          title: 'Lars&Sven Burgers',
          logo: '',
          pin_icon: '',
          category: 'restaurants',
          link: '',
          'second-floor': {
            'background-position': '-8px -435px',
            coords: '879,716,1104,802,1085,864,1062,918,913,855,899,878,820,845,824,792',
            height: '226',
            left: '825',
            pins: {
              height: '7',
              left: '907',
              'normal-background-position': '-895px -98px',
              top: '813',
              width: '10',
            },
            top: '694',
            width: '289',
          },
        },
        75: {
          id_shop: 56,
          title: 'Mladinska knjiga',
          logo: '',
          pin_icon: '',
          category: 'bookstores',
          link: '',
          'second-floor': {
            'background-position': '-669px -925px',
            coords: '692,532,729,546,727,559,681,607,681,641,626,621,627,589',
            height: '111',
            left: '631',
            pins: {
              height: '7',
              left: '678',
              'normal-background-position': '-895px -83px',
              top: '594',
              width: '10',
            },
            top: '532',
            width: '105',
          },
        },
        76: {
          id_shop: 82,
          title: 'Office Shoes',
          logo: '',
          pin_icon: '',
          category: 'shoes',
          link: '',
          'second-floor': {
            'background-position': '-722px -216px',
            coords: '646,521,687,535,626,589,626,622,600,612,583,615,583,577,269,939',
            height: '102',
            left: '588',
            pins: {
              height: '7',
              left: '623',
              'normal-background-position': '-779px -81px',
              top: '575',
              width: '10',
            },
            top: '521',
            width: '106',
          },
        },
        78: {
          id_shop: 79,
          title: 'Tom Tailor',
          logo: '',
          pin_icon: '',
          category: 'fashion',
          link: '',
          'second-floor': {
            'background-position': '-757px -820px',
            coords: '513,513,582,536,549,562,550,608,494,588,487,547,490,529',
            height: '97',
            left: '492',
            pins: {
              height: '7',
              left: '545',
              'normal-background-position': '-377px -148px',
              top: '549',
              width: '10',
            },
            top: '512',
            width: '98',
          },
        },
        79: {
          id_shop: 30,
          title: 'Sportina',
          logo: '',
          pin_icon: '',
          category: 'fashion',
          link: '',
          'second-floor': {
            'background-position': '-8px -189px',
            coords: '579,469,750,524,736,538,737,562,728,559,726,546,692,532,686,536,647,522,615,547,517,512',
            height: '93',
            left: '518',
            pins: {
              height: '7',
              left: '536',
              'normal-background-position': '-895px -68px',
              top: '506',
              width: '10',
            },
            top: '469',
            width: '241',
          },
        },
        80: {
          id_shop: 94,
          title: 'L Occitane',
          logo: '',
          pin_icon: '',
          category: 'drugstores',
          link: '',
          'second-floor': {
            'background-position': '-8px -148px',
            coords: '605,455,653,469,635,485,582,468',
            height: '33',
            left: '583',
            pins: {
              height: '7',
              left: '600',
              'normal-background-position': '-395px -148px',
              top: '462',
              width: '11',
            },
            top: '454',
            width: '77',
          },
        },
        81: {
          id_shop: 78,
          title: 'Europa 92',
          logo: '',
          pin_icon: '',
          category: 'fashion',
          link: '',
          'second-floor': {
            'background-position': '-721px -426px',
            coords: '656,439,707,458,664,495,634,488,653,469,608,454,623,447',
            height: '57',
            left: '583',
            pins: {
              height: '7',
              left: '627',
              'normal-background-position': '-722px -201px',
              top: '448',
              width: '9',
            },
            top: '439',
            width: '131',
          },
        },
        82: {
          id_shop: 87,
          title: 'Champion',
          logo: '',
          pin_icon: '',
          category: 'fashion',
          link: '',
          'second-floor': {
            'background-position': '-400px -851px',
            coords: '706,459,746,475,707,509,664,496',
            height: '65',
            left: '668',
            pins: {
              height: '7',
              left: '711',
              'normal-background-position': '-377px -163px',
              top: '466',
              width: '10',
            },
            top: '459',
            width: '91',
          },
        },
        83: {
          id_shop: 85,
          title: 'Rayher',
          logo: '',
          pin_icon: '',
          category: 'special',
          link: '',
          'second-floor': {
            'background-position': '-535px -291px',
            coords: '746,475,785,491,751,523,708,508',
            height: '50',
            left: '712',
            pins: {
              height: '7',
              left: '749',
              'normal-background-position': '-895px -53px',
              top: '481',
              width: '10',
            },
            top: '474',
            width: '81',
          },
        },
        84: {
          id_shop: 89,
          title: 'SIMPLE barber shop',
          logo: '',
          pin_icon: '',
          category: 'services',
          link: '',
          'second-floor': {
            'background-position': '-782px -995px',
            coords: '786,491,846,515,842,559,836,567,840,525,772,503',
            height: '82',
            left: '777',
            pins: {
              height: '7',
              left: '790',
              'normal-background-position': '-359px -148px',
              top: '497',
              width: '10',
            },
            top: '490',
            width: '78',
          },
        },
        85: {
          id_shop: 31,
          title: '7camicie',
          logo: '',
          pin_icon: '',
          category: 'fashion',
          link: '',
          'second-floor': {
            'background-position': '-860px -411px',
            coords: '812,516,840,526,837,569,826,586,829,543,797,531',
            height: '77',
            left: '802',
            pins: {
              height: '7',
              left: '829',
              'normal-background-position': '-376px -178px',
              top: '530',
              width: '10',
            },
            top: '515',
            width: '47',
          },
        },
        86: {
          id_shop: 76,
          title: 'Ciciban',
          logo: '',
          pin_icon: '',
          category: 'shoes',
          link: '',
          'second-floor': {
            'background-position': '-843px -324px',
            coords: '795,533,830,545,825,589,815,608,812,608,815,572,792,564,781,574,778,572,778,551',
            height: '79',
            left: '783',
            pins: {
              height: '7',
              left: '819',
              'normal-background-position': '-895px -38px',
              top: '549',
              width: '10',
            },
            top: '532',
            width: '56',
          },
        },
        87: {
          id_shop: 109,
          title: 'Deja Vous',
          logo: '',
          pin_icon: '',
          category: 'services',
          link: '',
          'second-floor': {
            'background-position': '-750px -720px',
            coords: '792,565,815,572,810,616,783,649,786,602,710,577,728,560,782,574',
            height: '92',
            left: '714',
            pins: {
              height: '7',
              left: '802',
              'normal-background-position': '-854px -215px',
              top: '572',
              width: '11',
            },
            top: '559',
            width: '108',
          },
        },
        88: {
          id_shop: 107,
          title: 'Bigg-R',
          logo: '',
          pin_icon: '',
          category: 'fashion',
          link: '',
          'second-floor': {
            'background-position': '-721px -491px',
            coords: '709,579,784,603,782,648,761,672,680,641,681,607',
            height: '96',
            left: '686',
            pins: {
              height: '7',
              left: '759',
              'normal-background-position': '-395px -163px',
              top: '618',
              width: '11',
            },
            top: '578',
            width: '106',
          },
        },
        89: {
          id_shop: 70,
          title: 'Knjigarna Felix',
          logo: '',
          pin_icon: '',
          category: 'bookstores',
          link: '',
          'second-floor': {
            'background-position': '0px 0px',
            coords: '623,405,663,419,649,437,624,439,616,425',
            height: 0,
            left: 0,
            pins: {
              height: '33',
              left: '631',
              'normal-background-position': '-864px -99px',
              top: '397',
              width: '20',
            },
            top: 0,
            width: 0,
          },
        },
        90: {
          id_shop: 68,
          title: 'Clever fit',
          logo: '',
          pin_icon: '',
          category: 'fashion',
          link: '',
          'second-floor': {
            'background-position': '-400px -924px',
            coords: '465,60,500,71,568,78,606,87,608,91,608,131,490,207,354,162,352,123',
            height: '149',
            left: '354',
            pins: {
              height: '7',
              left: '462',
              'normal-background-position': '-359px -163px',
              top: '67',
              width: '10',
            },
            top: '60',
            width: '261',
          },
        },
        16: {
          category: 'fashion',
          'first-floor': {
            'background-position': '-659px -659px',
            coords: '116,341,179,366,190,395,148,427,134,389,71,361',
            height: '90',
            left: '69',
            pins: {
              height: '7',
              left: '133',
              'normal-background-position': '-627px -321px',
              top: '379',
              width: '10',
            },
            top: '339',
            width: '123',
          },
        },
        17: {
          category: 'fashion',
          'first-floor': {
            'background-position': '-691px -211px',
            coords: '159,319,224,343,232,382,189,394,182,367,117,340',
            height: '78',
            left: '117',
            pins: {
              height: '7',
              left: '180',
              'normal-background-position': '-645px -321px',
              top: '354',
              width: '10',
            },
            top: '319',
            width: '117',
          },
        },
        18: {
          category: 'fashion',
          'first-floor': {
            'background-position': '-721px -297px',
            coords: '244,309,270,318,277,353,242,373,230,368,224,344,212,337,210,328',
            height: '73',
            left: '203',
            pins: {
              height: '7',
              left: '234',
              'normal-background-position': '-663px -321px',
              top: '325',
              width: '10',
            },
            top: '309',
            width: '78',
          },
        },
        19: {
          category: 'fashion',
          'first-floor': {
            'background-position': '-629px -469px',
            coords: '265,267,328,288,328,305,295,325,288,347,278,354,271,318,246,309,236,314,197,301',
            height: '88',
            left: '197',
            pins: {
              height: '7',
              left: '271',
              'normal-background-position': '-247px -351px',
              top: '305',
              width: '10',
            },
            top: '267',
            width: '138',
          },
        },
        2: {
          category: 'services',
          'first-floor': {
            'background-position': '-627px -860px',
            coords: '844,659,895,682,858,740,852,784,799,760,802,715',
            height: '128',
            left: '805',
            pins: {
              height: '7',
              left: '857',
              'normal-background-position': '-428px -139px',
              top: '725',
              width: '6',
            },
            top: '658',
            width: '99',
          },
        },
        43: {
          category: 'fashion',
          'first-floor': {
            'background-position': '-247px -366px',
            coords: '330,306,362,317,323,342,301,340,302,331,293,328',
            height: '37',
            left: '296',
            pins: {
              height: '7',
              left: '311',
              'normal-background-position': '-807px -346px',
              top: '332',
              width: '10',
            },
            top: '306',
            width: '72',
          },
        },
        48: {
          category: 'fashion',
          'first-floor': {
            'background-position': '0px 0px',
            coords: '441,478,472,493,454,519,424,504',
            height: 0,
            left: 0,
            pins: {
              height: '32',
              left: '447',
              'normal-background-position': '-564px -321px',
              top: '472',
              width: '19',
            },
            top: 0,
            width: 0,
          },
        },
        5: {
          category: 'fashion',
          'first-floor': {
            'background-position': '-600px -338px',
            coords: '654,582,716,606,668,657,667,700,609,674,607,631',
            height: '122',
            left: '610',
            pins: {
              height: '7',
              left: '668',
              'normal-background-position': '-816px -271px',
              top: '644',
              width: '5',
            },
            top: '581',
            width: '113',
          },
        },
        66: {
          category: 'fashion',
          'second-floor': {
            'background-position': '-370px -598px',
            coords: '841,382,984,418,965,439,840,451,791,439,772,451,768,483,696,452,698,426,726,401,819,403',
            height: '104',
            left: '703',
            pins: {
              height: '7',
              left: '767',
              'normal-background-position': '-883px -188px',
              top: '439',
              width: '10',
            },
            top: '381',
            width: '291',
          },
        },
        68: {
          'second-floor': {
            'background-position': '-8px -8px',
            coords:
              '985,417,1067,438,1063,458,1120,474,1108,515,1094,541,1090,539,1094,518,1058,507,922,513,898,545,846,525,848,515,821,504,822,473,841,452,967,439',
            height: '132',
            left: '703',
            pins: {
              height: '7',
              left: '914',
              'normal-background-position': '-883px -158px',
              top: '496',
              width: '10',
            },
            top: '416',
            width: '426',
          },
        },
        77: {
          'second-floor': {
            'background-position': '-819px -8px',
            coords: '585,536,615,548,583,578,583,615,576,617,548,607,549,564',
            height: '83',
            left: '553',
            pins: {
              height: '7',
              left: '581',
              'normal-background-position': '-797px -81px',
              top: '562',
              width: '10',
            },
            top: '536',
            width: '68',
          },
        },
      },
    },
  };

  // DOM element cache for performance
  const domCache = {};
  let currentCategory = 'all';

  // Cache DOM elements for frequent access
  const cacheDOMElements = () => {
    domCache.firstFloorMap = document.querySelector('[name="map-first-floor-map"]');
    domCache.secondFloorMap = document.querySelector('[name="map-second-floor-map"]');
    domCache.firstFloorContainer = document.querySelector('.map[data-floor="first-floor"]');
    domCache.secondFloorContainer = document.querySelector('.map[data-floor="second-floor"]');
    domCache.shopInfoByFloor = {
      'first-floor': {
        container: document.querySelector('.map-wrapper .shop-info[data-floor="first-floor"]'),
        image: document.querySelector('.map-wrapper .shop-info[data-floor="first-floor"] .shop-info-image'),
        title: document.querySelector('.map-wrapper .shop-info[data-floor="first-floor"] .shop-info-title'),
        more: document.querySelector('.map-wrapper .shop-info[data-floor="first-floor"] .shop-info-more'),
      },
      'second-floor': {
        container: document.querySelector('.map-wrapper .shop-info[data-floor="second-floor"]'),
        image: document.querySelector('.map-wrapper .shop-info[data-floor="second-floor"] .shop-info-image'),
        title: document.querySelector('.map-wrapper .shop-info[data-floor="second-floor"] .shop-info-title'),
        more: document.querySelector('.map-wrapper .shop-info[data-floor="second-floor"] .shop-info-more'),
      },
    };
    domCache.allMapOverlays = document.querySelectorAll('.map-wrapper .map-shop-overlay');
    domCache.allMapPins = document.querySelectorAll('.map-wrapper .map-shop-pin');
    domCache.allShopInfos = document.querySelectorAll('.map-wrapper .shop-info');
    domCache.mapAreas = document.querySelectorAll(
      '.map-wrapper [name="map-first-floor-map"] area, .map-wrapper [name="map-second-floor-map"] area',
    );
    domCache.floorSwitchButtons = document.querySelectorAll('.map-wrapper .switch-map');
    domCache.shopList = document.getElementById('shop-list');
    domCache.categoryFilters = document.querySelectorAll('.map-wrapper .dropdown__list-item input');
  };

  // Helper to create and append element with attributes
  const createElement = (tag, attributes = {}, parent = null) => {
    const element = document.createElement(tag);

    Object.entries(attributes).forEach(([key, value]) => {
      if (key === 'className') {
        element.className = value;
      } else {
        element.setAttribute(key, value);
      }
    });

    if (parent) {
      parent.appendChild(element);
    }

    return element;
  };

  // Create map areas more efficiently
  const createMapAreas = () => {
    // Create document fragment for better performance
    const firstFloorFragment = document.createDocumentFragment();
    const secondFloorFragment = document.createDocumentFragment();

    Object.entries(script_settings.map.shops_by_internal_number).forEach(([internalNumber, shop]) => {
      if (!shop.title || !shop.link || !shop.logo) return;
      // Create first floor map areas
      if (shop['first-floor']) {
        const firstFloorArea = createElement('area', {
          'data-floor': 'first-floor',
          'data-internal-number': internalNumber,
          shape: 'poly',
          coords: shop['first-floor'].coords,
          href: shop.link,
        });
        firstFloorFragment.appendChild(firstFloorArea);
      }

      // Create second floor map areas
      if (shop['second-floor']) {
        const secondFloorArea = createElement('area', {
          'data-floor': 'second-floor',
          'data-internal-number': internalNumber,
          shape: 'poly',
          coords: shop['second-floor'].coords,
          href: shop.link,
        });
        secondFloorFragment.appendChild(secondFloorArea);
      }
    });

    domCache.firstFloorMap.appendChild(firstFloorFragment);
    domCache.secondFloorMap.appendChild(secondFloorFragment);
  };

  // Create map overlays and pins more efficiently
  const createOverlaysAndPins = () => {
    const firstFloorFragment = document.createDocumentFragment();
    const secondFloorFragment = document.createDocumentFragment();

    Object.entries(script_settings.map.shops_by_internal_number).forEach(([internalNumber, shop]) => {
      if (shop['first-floor']) {
        // Create overlay for first floor
        const overlay = createElement('div', {
          className: 'map-shop-overlay',
          'data-floor': 'first-floor',
          'data-internal-number': internalNumber,
        });
        firstFloorFragment.appendChild(overlay);

        // Create pin for first floor
        const pin = createElement('div', {
          className: 'map-shop-pin bounce-pin',
          'data-floor': 'first-floor',
          'data-internal-number': internalNumber,
        });

        createElement('div', { className: 'map-pin-normal' }, pin);
        createElement('div', { className: 'map-pin-hover' }, pin);

        firstFloorFragment.appendChild(pin);
      }

      if (shop['second-floor']) {
        // Create overlay for second floor
        const overlay = createElement('div', {
          className: 'map-shop-overlay',
          'data-floor': 'second-floor',
          'data-internal-number': internalNumber,
        });
        secondFloorFragment.appendChild(overlay);

        // Create pin for second floor
        const pin = createElement('div', {
          className: 'map-shop-pin bounce-pin',
          'data-floor': 'second-floor',
          'data-internal-number': internalNumber,
        });

        createElement('div', { className: 'map-pin-normal' }, pin);
        createElement('div', { className: 'map-pin-hover' }, pin);

        secondFloorFragment.appendChild(pin);
      }
    });

    domCache.firstFloorContainer.appendChild(firstFloorFragment);
    domCache.secondFloorContainer.appendChild(secondFloorFragment);
  };

  // Create shops list with category data directly from shop objects
  const createShopsList = () => {
    // Process all shops from script_settings
    Object.entries(script_settings.map.shops_by_internal_number).forEach(([internalNumber, shop]) => {
      if (!shop.title || !shop.link) return;

      // Determine floors where shop is located
      const floors = [];
      if (shop['first-floor']) floors.push('first-floor');
      if (shop['second-floor']) floors.push('second-floor');
      if (floors.length === 0) return;

      // Get category from shop object
      const shopCategory = shop.category || 'fashion'; // Default to fashion if category not defined

      // Create shop link element
      const shopElement = createElement(
        'a',
        {
          className: `shop category--${shopCategory}`,
          href: shop.link,
          'data-floors': floors.join(','),
          'data-internal-number': internalNumber,
          'data-category': shopCategory,
        },
        domCache.shopList,
      );

      // Create pin element inside shop element
      const pinElement = createElement('div', { className: `pin pin--${shopCategory}` }, shopElement);
      pinElement.textContent = internalNumber;

      // Add shop name
      shopElement.appendChild(document.createTextNode(` ${shop.title}`));

      createElement(
        'img',
        {
          src: shop.pin_icon,
          alt: shopCategory,
          width: 50,
          height: 50,
        },
        pinElement,
      );
    });
  };

  // Initialize category filter functionality
  const initCategoryFilters = () => {
    domCache.categoryFilters.forEach((filterItem) => {
      filterItem.addEventListener('change', () => {
        currentCategory = filterItem.getAttribute('data-category');
        filterShops(currentCategory);
      });
    });
  };

  // Function to filter shops by category
  const filterShops = (category) => {
    const activeMap = document.querySelector('.map-wrapper .map.active');
    if (!activeMap) return;

    const activeFloor = activeMap.getAttribute('data-floor');

    document.querySelectorAll('.shop').forEach((shop) => {
      const shopCategory = shop.getAttribute('data-category');
      const shopFloors = shop.getAttribute('data-floors').split(',');

      const matchesCategory = category === 'all' || shopCategory === category;
      const matchesFloor = shopFloors.includes(activeFloor);

      if (matchesCategory && matchesFloor) {
        shop.classList.remove('is-hidden');
      } else {
        shop.classList.add('is-hidden');
      }
    });
  };

  // Filter shops based on the active floor
  const filterShopsByActiveFloor = () => {
    const activeMap = document.querySelector('.map-wrapper .map.active');
    if (!activeMap) return;

    const activeFloor = activeMap.getAttribute('data-floor');

    document.querySelectorAll('.shop').forEach((shop) => {
      const shopFloors = shop.getAttribute('data-floors').split(',');
      if (shopFloors.includes(activeFloor)) {
        shop.classList.remove('is-hidden');
      } else {
        shop.classList.add('is-hidden');
      }
    });
  };

  // Map functionality
  document.addEventListener('DOMContentLoaded', () => {
    const dataItems = document.querySelectorAll('.shop-map-old__data-item');

    for (const item of dataItems) {
      const { shopNumber } = item.dataset; // e.g., "1"

      if (Object.prototype.hasOwnProperty.call(script_settings.map.shops_by_internal_number, shopNumber)) {
        const shopData = script_settings.map.shops_by_internal_number[shopNumber];
        shopData.title = item.dataset.title;
        shopData.category = item.dataset.category;
        shopData.link = item.dataset.link;
        shopData.logo = item.dataset.logo;
        shopData.pin_icon = item.dataset.pin;
      }
    }

    // Cache DOM elements first
    cacheDOMElements();

    // Create map areas, overlays and pins
    createMapAreas();
    createOverlaysAndPins();

    // Create shops list
    createShopsList();

    // Initialize category filters
    initCategoryFilters();
    filterShopsByActiveFloor();

    // Re-cache elements created dynamically
    domCache.allMapOverlays = document.querySelectorAll('.map-wrapper .map-shop-overlay');
    domCache.allMapPins = document.querySelectorAll('.map-wrapper .map-shop-pin');

    // Function to show shop info - using cached elements
    const showShopInfo = (floor, internalNumber) => {
      const shop = script_settings.map.shops_by_internal_number[internalNumber];

      if (shop) {
        const floorInfo = domCache.shopInfoByFloor[floor];
        floorInfo.image.style.backgroundImage = `url("${shop.logo}")`;
        floorInfo.title.innerHTML = shop.title;
        floorInfo.more.setAttribute('href', shop.link);
        floorInfo.container.classList.add('visible');
      }
    };

    // Function to handle area hover
    const areaHoverHandler = (floor, internalNumber) => {
      const selector = `[data-floor="${floor}"][data-internal-number="${internalNumber}"]`;
      const overlay = document.querySelector(`.map-wrapper .map-shop-overlay${selector}`);
      const pin = document.querySelector(`.map-wrapper .map-shop-pin${selector}`);

      if (overlay) overlay.classList.add('active');
      if (pin) pin.classList.add('active');

      showShopInfo(floor, internalNumber);
    };

    // Function to deactivate all areas
    const deactivateAllAreas = () => {
      domCache.allMapOverlays.forEach((overlay) => overlay.classList.remove('active'));
      domCache.allMapPins.forEach((pin) => pin.classList.remove('active'));
      domCache.allShopInfos.forEach((info) => info.classList.remove('visible'));
    };

    // Add event delegation to reduce number of event listeners
    const mapAreaContainer = document.querySelector('.map-wrapper');

    mapAreaContainer.addEventListener('mouseover', (e) => {
      const area = e.target.closest('area');
      if (area) {
        deactivateAllAreas();
        areaHoverHandler(area.getAttribute('data-floor'), area.getAttribute('data-internal-number'));
      }
    });

    // Touch events for mobile
    mapAreaContainer.addEventListener(
      'touchstart',
      (e) => {
        const area = e.target.closest('area');
        if (area) {
          deactivateAllAreas();
          areaHoverHandler(area.getAttribute('data-floor'), area.getAttribute('data-internal-number'));
        }
      },
      { passive: false },
    );

    mapAreaContainer.addEventListener(
      'touchend',
      (e) => {
        const area = e.target.closest('area');
        if (area) {
          e.preventDefault();
        }
      },
      { passive: false },
    );

    mapAreaContainer.addEventListener('click', (e) => {
      const area = e.target.closest('area');
      if (area && script_settings.map.is_ios) {
        e.preventDefault();
      }
    });

    // Floor switch functionality with event delegation
    const switchContainer = document.querySelector('.map-wrapper');

    switchContainer.addEventListener('click', (e) => {
      const switchBtn = e.target.closest('.switch-map');
      if (!switchBtn) return;

      const floor = switchBtn.getAttribute('data-floor');

      // Remove active class from all maps and switches
      document
        .querySelectorAll('.map-wrapper .map.active, .map-wrapper .switch-map.active')
        .forEach((el) => el.classList.remove('active'));

      // Add active class to the selected floor map and switch
      document.querySelector(`.map-wrapper .map[data-floor="${floor}"]`).classList.add('active');
      document.querySelector(`.map-wrapper .switch-map[data-floor="${floor}"]`).classList.add('active');

      // Hide all shop info
      domCache.allShopInfos.forEach((info) => info.classList.remove('visible'));

      // Update visible shops based on selected floor
      filterShopsByActiveFloor();

      // Re-apply the current category filter on new floor
      filterShops(currentCategory);
    });

    // Shop link hover/click functionality for categories
    const categoriesContainer = document.querySelector('.categories-container');

    categoriesContainer.addEventListener('mouseover', (e) => {
      const shopLink = e.target.closest('.shop');
      if (shopLink) {
        const internalNumber = shopLink.getAttribute('data-internal-number');
        const floors = shopLink.getAttribute('data-floors').split(',');

        if (floors.length > 0 && internalNumber) {
          deactivateAllAreas();
          areaHoverHandler(floors[0], internalNumber);

          // If needed, highlight the correct map floor
          const activeMap = document.querySelector('.map-wrapper .map.active');
          const activeFloor = activeMap.getAttribute('data-floor');

          if (!floors.includes(activeFloor)) {
            // Switch to the floor where the shop is located
            document.querySelector(`.switch-map[data-floor="${floors[0]}"]`).click();
          }
        }
      }
    });

    categoriesContainer.addEventListener('click', (e) => {
      const shopLink = e.target.closest('.shop');
      if (shopLink && script_settings.map.is_ios) {
        e.preventDefault();
      }
    });

    // Switch floor if second floor is passed from url
    const url = new URL(window.location.href);
    const floorFromUrl = url.hash.replace('#', '');
    if (floorFromUrl) {
      const floorElement = document.querySelector(`[data-floor-label="${floorFromUrl}"]`);
      floorElement?.click();
    }
  });
}
